<template>
  <div>
    <VBusHelper :reactOn="constants.EVENTS.WALLET.MODAL_OPEN" :handler="showWallet" />
    <DialogComponent
      ref="dialog"
      dialogId="wallet-dialog"
      type="bottomsheet"
      noInnerPadding
    >
      <WalletBottomSheet
        @close="hideWallet"
      />
    </DialogComponent>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue';
import WalletBottomSheet from './WalletBottomSheet.vue';
import constants from '@core/utils/constants';

const dialog = ref(null);
const { proxy } = getCurrentInstance();
const { $bus } = proxy;

const showWallet = async () => {
  dialog.value?.show();
};

const hideWallet = () => {
  dialog.value?.hide();
};
</script>
